// import React from "react";
// import Layout from "./Layout";

// const Refrel = () => {
//   return (
//     <Layout>
//       <div className="px-2 my-4">
//         <div className="justify-space-around referralLayout hidden-md-and-up v-card v-sheet theme--light elevation-0">
//           <div className="v-image v-responsive theme--light">
//             <div
//               className="v-responsive__sizer"
//               style={{ "padding-bottom": "23.0769%" }}
//             />
//             <div
//               className="v-image__image v-image__image--cover"
//               style={{
//                 "background-image":
//                   'url("https://jiliwin.9terawolf.com/images/jaya9/game_banner/referral_banner2.jpg")',
//                 "background-position": "center center",
//               }}
//             />
//             <div className="v-responsive__content">
//               <div className="row fill-height no-gutters justify-end">
//                 <div className="col col-12">
//                   <div className="mobile-referral-expansion v-item-group theme--light v-expansion-panels v-expansion-panels--accordion v-expansion-panels--flat">
//                     <div aria-expanded="false" className="v-expansion-panel">
//                       <button
//                         type="button"
//                         className="v-expansion-panel-header white--text"
//                       >
//                         <label className="white--text">Referral Program</label>
//                         <div className="v-expansion-panel-header__icon">
//                           <i
//                             aria-hidden="true"
//                             className="v-icon notranslate mdi mdi-chevron-down theme--light"
//                           />
//                         </div>
//                       </button>
//                       {/**/}
//                     </div>
//                   </div>
//                 </div>
//                 <div className="text-end d-flex justify-center align-end col col-12">
//                   <a
//                     href="/referral/summary"
//                     className="referral-tab-mobile mobile-nav-active v-btn--active v-btn v-btn--has-bg v-btn--router theme--light elevation-0 v-size--default"
//                   >
//                     <span className="v-btn__content">
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="24.967"
//                         height={25}
//                         className="mobile-icon"
//                       >
//                         <defs />
//                         <path
//                           d="M13.27.007c.465.066.93.118 1.4.192a12.484 12.484 0 019.866 8.98c.118.458.214.916.3 1.381.066.384.1.775.14 1.182h-3.421A9.118 9.118 0 008.61 4.284c-.561-.975-1.13-1.957-1.735-3.005C7.613 1.013 8.3.696 9.024.511c.82-.214 1.669-.31 2.511-.465l.185-.044c.516.005 1.033.005 1.55.005zM.007 11.712c.066-.48.111-.967.2-1.44a12.377 12.377 0 015.28-8.108.5.5 0 01.081-.052.3.3 0 01.074-.015q.842 1.451 1.691 2.924a9.111 9.111 0 000 14.946c-.561.975-1.122 1.95-1.713 2.969-.354-.266-.709-.51-1.034-.775a12.4 12.4 0 01-4.475-7.99c-.044-.3-.074-.591-.111-.894.007-.524.007-1.048.007-1.565zM6.875 23.682c.6-1.034 1.159-2.009 1.721-2.983a9.113 9.113 0 0012.945-7.459h3.426a12.17 12.17 0 01-5.516 9.6c-3.988 2.651-8.204 2.776-12.576.842z"
//                           className="a"
//                         />
//                         <path
//                           d="M12.502 4.881a7.606 7.606 0 107.6 7.628 7.622 7.622 0 00-7.6-7.628zM9.659 15.633a.719.719 0 01-.982.7.732.732 0 01-.473-.724c-.007-.3 0-.6 0-.894V9.354a.74.74 0 01.709-.842.708.708 0 01.746.768c.007.894 0 1.794 0 2.688v.487c0 1.058.008 2.114 0 3.178zm2.555-.03a.742.742 0 01-.576.768.711.711 0 01-.8-.4 1.034 1.034 0 01-.074-.4c-.007-.775 0-1.551 0-2.326v-2.356a.73.73 0 111.455-.015c.003 1.569.003 3.149-.005 4.729zm2.444-3.19v3.2a.717.717 0 01-1.314.4.916.916 0 01-.133-.458 953.421 953.421 0 010-6.328.728.728 0 111.455 0c-.008 1.067-.008 2.13-.008 3.186zm2.415 3.146a.729.729 0 11-1.455-.015v-3.057a.728.728 0 111.455-.015c.009 1.041.009 2.06 0 3.087z"
//                           className="a"
//                         />
//                       </svg>
//                       <span className="ml-1">Summary</span>
//                     </span>
//                   </a>
//                   <a
//                     href="/referral/report"
//                     className="referral-tab-mobile v-btn v-btn--has-bg v-btn--router theme--light elevation-0 v-size--default"
//                   >
//                     <span className="v-btn__content">
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="23.099"
//                         height={25}
//                         className="mobile-icon"
//                       >
//                         <defs />
//                         <path
//                           d="M13.991 0v3.943a1.542 1.542 0 001.718 1.707h3.76v2.1H4.613c-.508 0-.605.076-.756.54h-1.21c-.486 0-.659.151-.648.627 0 .583.011 1.167.022 1.75.011.432.162.583.605.583h1.232c.054.519.421.551.821.54.205-.011.411 0 .648 0v.61a.97.97 0 001.08 1.08h5.283a1.44 1.44 0 00.3-.032.411.411 0 00.346-.443.419.419 0 00-.346-.432 1.759 1.759 0 00-.335-.032h-5.38v-.724h13.191v11.344a1.706 1.706 0 01-1.707 1.826 3.036 3.036 0 01-.313.011H1.977a2.006 2.006 0 01-1.48-.508 1.739 1.739 0 01-.5-1.329V1.675A1.669 1.669 0 011.52.011C1.66 0 1.801 0 1.941 0h12.046zm-4.84 22.483h6.461a1.521 1.521 0 00.313-.011.435.435 0 00.389-.443.428.428 0 00-.378-.454 1.186 1.186 0 00-.281-.022H2.7a2.656 2.656 0 00-.3.022.422.422 0 00-.367.432.444.444 0 00.346.454 1.167 1.167 0 00.335.022zm.022-3.209H2.712a1.745 1.745 0 00-.335.022.431.431 0 00-.357.443.406.406 0 00.357.432 1.758 1.758 0 00.335.032h13.094a.491.491 0 00.5-.475.486.486 0 00-.508-.465h-.227c-2.12.011-4.259.011-6.399.011zm-.022-2.269H2.744a1.737 1.737 0 00-.335.011.454.454 0 00.011.9 2.35 2.35 0 00.281.011h12.954a1.6 1.6 0 00.227-.011.471.471 0 00.443-.465.463.463 0 00-.454-.454 2.437 2.437 0 00-.281 0c-2.15.008-4.3.008-6.439.008zM6.3 15.655h3.662a1.377 1.377 0 00.3-.022.424.424 0 00.346-.454.415.415 0 00-.367-.432 1.427 1.427 0 00-.3-.022H2.69c-.108 0-.259-.022-.324.043a.953.953 0 00-.324.4.369.369 0 00.281.454 1.29 1.29 0 00.357.043c1.209-.01 2.409-.01 3.62-.01z"
//                           className="a"
//                         />
//                         <path
//                           d="M4.829 10.836V8.729h16.379v2.107zM18.755 4.71c-.14.011-.216.022-.3.022H15.72c-.583 0-.8-.216-.8-.8V.745zM3.868 10.329H2.96V9.27h.908zM22.072 9.129c.367.238.681.443 1.026.67a51.3 51.3 0 00-1.026.67z"
//                           className="a"
//                         />
//                       </svg>
//                       {/**/}
//                     </span>
//                   </a>
//                   <a
//                     href="/referral/history"
//                     className="referral-tab-mobile v-btn v-btn--has-bg v-btn--router theme--light elevation-0 v-size--default"
//                   >
//                     <span className="v-btn__content">
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="24.986"
//                         height={25}
//                         className="mobile-icon"
//                       >
//                         <defs />
//                         <path
//                           d="M13.222.014c.479.063.966.12 1.445.2a11.716 11.716 0 012.46.7c-.176.451-.352.888-.536 1.346a10.926 10.926 0 00-9.734.775 10.485 10.485 0 00-4.8 5.871A11.031 11.031 0 1021.32 5.953c-.049.367-.1.7-.148 1.064-.486-.063-.959-.127-1.445-.183.141-1.128.282-2.227.43-3.348H23.5v1.438h-1.073c.07.106.106.169.155.233a12.279 12.279 0 012.361 6.407c.007.07.028.141.042.211v1.515l-.042.211c-.106.655-.162 1.325-.31 1.966a12.441 12.441 0 01-9.966 9.339c-.465.078-.93.127-1.4.19h-1.511l-.211-.042c-.655-.1-1.325-.162-1.966-.31A12.512 12.512 0 01.191 14.65c-.078-.458-.127-.916-.19-1.374v-1.562c.063-.465.113-.93.19-1.4A12.482 12.482 0 0110.29.2c.472-.078.944-.134 1.424-.2.501.014 1.001.014 1.508.014z"
//                           className="a"
//                         />
//                         <path
//                           d="M12.496 20.75a8.246 8.246 0 118.239-8.239 8.26 8.26 0 01-8.239 8.239zm3.376-9.05h-2.593V9.127h-1.565v4.151h4.158z"
//                           className="a"
//                         />
//                       </svg>
//                       {/**/}
//                     </span>
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="v-card__text referralContainer">
//             <div>
//               <div className="row">
//                 <div className="col-md-5 col-12">
//                   <div className="row">
//                     <div className="col col-12">
//                       <div className="commission-content-holder full-height primary white--text text-center pa-2 mb-3 v-card v-sheet theme--light elevation-0">
//                         <div className="v-card__text">
//                           <div className="row no-gutters justify-center">
//                             <div className="mb-3 col col-9">
//                               <label className="white--text">
//                                 Commission To Redeem
//                               </label>
//                             </div>
//                             <div className="mb-0 col col-9">
//                               <form noValidate="novalidate" className="v-form">
//                                 <div className="mobile">
//                                   <div className="row no-gutters justify-space-between">
//                                     <div no-gutters className="col col-10">
//                                       {/**/}
//                                     </div>
//                                     <div no-gutters className="col col-2">
//                                       {/**/}
//                                     </div>
//                                     <div no-gutters className="col col-12">
//                                       <div className="v-input input-field elevation-0 hide-details v-input--is-label-active v-input--is-dirty v-input--is-disabled v-input--is-readonly theme--light v-text-field v-text-field--prefix v-text-field--is-booted v-text-field--enclosed v-text-field--outlined commission-redeem-field input-field elevation-0 hide-details">
//                                         <div className="v-input__control">
//                                           <div className="v-input__slot">
//                                             <fieldset aria-hidden="true">
//                                               <legend style={{ width: "0px" }}>
//                                                 <span className="notranslate">
//                                                   ​
//                                                 </span>
//                                               </legend>
//                                             </fieldset>
//                                             <div className="v-text-field__slot">
//                                               <div className="v-text-field__prefix">
//                                                 ৳
//                                               </div>
//                                               <input
//                                                 autoComplete="new-password"
//                                                 autofocus="autofocus"
//                                                 disabled="disabled"
//                                                 id="input-1033"
//                                                 placeholder
//                                                 readOnly="readonly"
//                                                 type="text"
//                                               />
//                                             </div>
//                                           </div>
//                                           <div className="v-text-field__details">
//                                             <div className="v-messages theme--light">
//                                               <div className="v-messages__wrapper" />
//                                             </div>
//                                           </div>
//                                         </div>
//                                       </div>
//                                       {/**/}
//                                       {/**/}
//                                     </div>
//                                   </div>
//                                 </div>
//                               </form>
//                             </div>
//                             <div className="col col-9">
//                               <button
//                                 data-v-3b7d3367
//                                 type="button"
//                                 className="pa-2 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default dialog-button text-capitalize"
//                               >
//                                 <span className="v-btn__content">Redeem</span>
//                               </button>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="col-sm-6 col-md-5 col-12">
//                       <div className="row no-gutters align-end">
//                         <div className="col col-12">
//                           <label>Today Commission</label>
//                         </div>
//                       </div>
//                       <div className="row no-gutters">
//                         <div className="col col-12">
//                           <div className="v-card v-sheet theme--light primary white--text text-left py-2 pl-6 mb-3">
//                             ৳ 0.00
//                           </div>
//                         </div>
//                       </div>
//                       <div className="row no-gutters align-end">
//                         <div className="col col-12">
//                           <label>This Month Commission</label>
//                         </div>
//                       </div>
//                       <div className="row no-gutters align-start">
//                         <div className="col col-12">
//                           <div className="v-card v-sheet theme--light primary white--text text-left py-2 pl-6">
//                             ৳ 0.00
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="col-sm-6 col-md-6 col-12">
//                       <div className="row">
//                         <div className="col col-12">
//                           <div className="tier-container">Referral Tier</div>
//                         </div>
//                       </div>
//                       <div className="row no-gutters align-end">
//                         <div className="col col-6">
//                           <div className="v-card v-sheet theme--light elevation-0 border-left-radius primary white--text text-center pa-2 mb-3 mr-1">
//                             Total
//                           </div>
//                         </div>
//                         <div className="col col-6">
//                           <div className="v-card v-sheet theme--light elevation-0 border-right-radius primary white--text text-center pa-2 mb-3 mr-1">
//                             0
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="col-md-7 col-12">
//                   <div className="row no-gutters">
//                     {/**/}
//                     <div className="col-sm-7 col-md-7 col-12">
//                       <div className="commission-content-holder base pa-2 mb-3 full-height v-card v-sheet theme--light elevation-0">
//                         <div className="v-card__text">
//                           <div className="row no-gutters">
//                             <div
//                               className="d-flex flex-column justify-center col-md-7 col-10"
//                               style={{ margin: "auto" }}
//                             >
//                               <div className="row no-gutters">
//                                 <div className="col">ID:</div>
//                                 <div className="font-weight-bold text-right col">
//                                   5633194
//                                 </div>
//                               </div>
//                               <div className="row no-gutters">
//                                 <div className="col">Referral Code:</div>
//                                 <div className="font-weight-bold text-right col">
//                                   GMHJEP94326
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                           <div className="row d-flex justify-center">
//                             <div className="d-flex justify-center col col-12">
//                               <div
//                                 className="qrCode"
//                                 title="https://winx9.ne?refer_code=GMHJEP94326"
//                               >
//                                 <canvas
//                                   width={105}
//                                   height={105}
//                                   style={{ display: "none !important" }}
//                                 />
//                                 <img
//                                   alt="Scan me!"
//                                   src="data:image/png;base64,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"
//                                   style={{ display: "block !important" }}
//                                 />
//                               </div>
//                             </div>
//                             <div className="mb-0 col-sm-8 col-md-12 col-12">
//                               <div className="row no-gutters justify-center">
//                                 <div className="col-lg-6 col-8">
//                                   <button
//                                     type="button"
//                                     className="dialog-button subtitle-1 full-width text-capitalize pa-2 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
//                                   >
//                                     <span className="v-btn__content">
//                                       <i
//                                         aria-hidden="true"
//                                         className="v-icon notranslate mr-2 material-icons theme--light"
//                                       >
//                                         share
//                                       </i>
//                                       Share Now
//                                     </span>
//                                   </button>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div
//                 className="v-snack pa-0 v-snack--centered v-snack--has-background v-snack--top"
//                 style={{
//                   "padding-bottom": "0px",
//                   "padding-top": "0px",
//                   "z-index": "1000 !important",
//                   top: "7%",
//                 }}
//               >
//                 <div
//                   className="v-snack__wrapper v-sheet theme--light"
//                   style={{ width: "fit-content", display: "none" }}
//                 >
//                   <div
//                     role="status"
//                     aria-live="polite"
//                     className="v-snack__content"
//                   >
//                     <div
//                       role="alert"
//                       className="v-alert mb-0 pa-1 v-sheet theme--light profile-alert-failed"
//                       style={{ display: "none" }}
//                     >
//                       <div className="v-alert__wrapper">
//                         <i
//                           aria-hidden="true"
//                           className="v-icon notranslate v-alert__icon material-icons theme--light"
//                         >
//                           cancel
//                         </i>
//                         <div className="v-alert__content"></div>
//                         <button
//                           type="button"
//                           className="v-alert__dismissible v-btn v-btn--icon v-btn--round theme--light v-size--small"
//                           aria-label="Close"
//                         >
//                           <span className="v-btn__content">
//                             <i
//                               aria-hidden="true"
//                               className="v-icon notranslate material-icons theme--light"
//                             >
//                               close
//                             </i>
//                           </span>
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="v-snack__action " />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </Layout>
//   );
// };

// export default Refrel;

import React from "react";
import { useTranslation } from "react-i18next";
import Layout from "./Layout";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { QRCodeCanvas } from "qrcode.react";
import { isEmpty } from "lodash";

const Refrel = () => {
  const { t } = useTranslation();
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const profileData = useContextSelector(AuthContext, (ctx) => ctx.profileData);
  const setLoginModalShow = useContextSelector(
    AuthContext,
    (ctx) => ctx.setLoginModalShow,
  );

  const referralUrl = `https://${window.location.hostname}/register?referral_code=${profileData?.referalCode}`;

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: t("ReferAFriend"),
          text: t("JoinBonusText"),
          url: referralUrl,
        });
      } catch (error) {
        console.log("Error sharing:", error);
      }
    } else {
      alert(t("SharingNotSupported"));
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(referralUrl)
      .then(() => {
        toast.success(t("CopiedToClipboard"));
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };
  const navigate = useNavigate();
  return (
    <Layout>
      <div className="px-2 my-4">
        <div className="justify-space-around referralLayout hidden-md-and-up v-card v-sheet theme--light elevation-0">
          <div className="v-image v-responsive theme--light">
            <div
              className="v-responsive__sizer"
              style={{ paddingBottom: "23.0769%" }}
            />
            <div
              className="v-image__image v-image__image--cover"
              style={{
                backgroundImage:
                  'url("/assets/images/referral_banner2.webp")',
                backgroundPosition: "center center",
              }}
            />
            <div className="v-responsive__content">
              <div className="row fill-height no-gutters justify-end">
                <div className="col col-12">
                  <div className="mobile-referral-expansion v-item-group theme--light v-expansion-panels v-expansion-panels--accordion v-expansion-panels--flat">
                    <div aria-expanded="false" className="v-expansion-panel">
                      <button
                        type="button"
                        className="v-expansion-panel-header white--text"
                      >
                        <label className="white--text">{t("ReferralProgram")}</label>
                        <div className="v-expansion-panel-header__icon">
                          <i
                            aria-hidden="true"
                            className="v-icon notranslate mdi mdi-chevron-down theme--light"
                          />
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="text-end d-flex justify-center align-end col col-12">
                  <Link
                    to="/referral/summary"
                    className="referral-tab-mobile mobile-nav-active v-btn--active v-btn v-btn--has-bg v-btn--router theme--light elevation-0 v-size--default"
                  >
                    <span className="v-btn__content">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24.967"
                        height={25}
                        className="mobile-icon"
                      >
                        <defs />
                        <path
                          d="M13.27.007c.465.066.93.118 1.4.192a12.484 12.484 0 019.866 8.98c.118.458.214.916.3 1.381.066.384.1.775.14 1.182h-3.421A9.118 9.118 0 008.61 4.284c-.561-.975-1.13-1.957-1.735-3.005C7.613 1.013 8.3.696 9.024.511c.82-.214 1.669-.31 2.511-.465l.185-.044c.516.005 1.033.005 1.55.005zM.007 11.712c.066-.48.111-.967.2-1.44a12.377 12.377 0 015.28-8.108.5.5 0 01.081-.052.3.3 0 01.074-.015q.842 1.451 1.691 2.924a9.111 9.111 0 000 14.946c-.561.975-1.122 1.95-1.713 2.969-.354-.266-.709-.51-1.034-.775a12.4 12.4 0 01-4.475-7.99c-.044-.3-.074-.591-.111-.894.007-.524.007-1.048.007-1.565zM6.875 23.682c.6-1.034 1.159-2.009 1.721-2.983a9.113 9.113 0 0012.945-7.459h3.426a12.17 12.17 0 01-5.516 9.6c-3.988 2.651-8.204 2.776-12.576.842z"
                          className="a"
                        />
                        <path
                          d="M12.502 4.881a7.606 7.606 0 107.6 7.628 7.622 7.622 0 00-7.6-7.628zM9.659 15.633a.719.719 0 01-.982.7.732.732 0 01-.473-.724c-.007-.3 0-.6 0-.894V9.354a.74.74 0 01.709-.842.708.708 0 01.746.768c.007.894 0 1.794 0 2.688v.487c0 1.058.008 2.114 0 3.178zm2.555-.03a.742.742 0 01-.576.768.711.711 0 01-.8-.4 1.034 1.034 0 01-.074-.4c-.007-.775 0-1.551 0-2.326v-2.356a.73.73 0 111.455-.015c.003 1.569.003 3.149-.005 4.729zm2.444-3.19v3.2a.717.717 0 01-1.314.4.916.916 0 01-.133-.458 953.421 953.421 0 010-6.328.728.728 0 111.455 0c-.008 1.067-.008 2.13-.008 3.186zm2.415 3.146a.729.729 0 11-1.455-.015v-3.057a.728.728 0 111.455-.015c.009 1.041.009 2.06 0 3.087z"
                          className="a"
                        />
                      </svg>
                      <span className="ml-1">{t("Summary")}</span>
                    </span>
                  </Link>
                  <Link
                    to="/referral/report"
                    className="referral-tab-mobile v-btn v-btn--has-bg v-btn--router theme--light elevation-0 v-size--default"
                  >
                    <span className="v-btn__content">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="23.099"
                        height={25}
                        className="mobile-icon"
                      >
                        <defs />
                        <path
                          d="M13.991 0v3.943a1.542 1.542 0 001.718 1.707h3.76v2.1H4.613c-.508 0-.605.076-.756.54h-1.21c-.486 0-.659.151-.648.627 0 .583.011 1.167.022 1.75.011.432.162.583.605.583h1.232c.054.519.421.551.821.54.205-.011.411 0 .648 0v.61a.97.97 0 001.08 1.08h5.283a1.44 1.44 0 00.3-.032.411.411 0 00.346-.443.419.419 0 00-.346-.432 1.759 1.759 0 00-.335-.032h-5.38v-.724h13.191v11.344a1.706 1.706 0 01-1.707 1.826 3.036 3.036 0 01-.313.011H1.977a2.006 2.006 0 01-1.48-.508 1.739 1.739 0 01-.5-1.329V1.675A1.669 1.669 0 011.52.011C1.66 0 1.801 0 1.941 0h12.046zm-4.84 22.483h6.461a1.521 1.521 0 00.313-.011.435.435 0 00.389-.443.428.428 0 00-.378-.454 1.186 1.186 0 00-.281-.022H2.7a2.656 2.656 0 00-.3.022.422.422 0 00-.367.432.444.444 0 00.346.454 1.167 1.167 0 00.335.022zm.022-3.209H2.712a1.745 1.745 0 00-.335.022.431.431 0 00-.357.443.406.406 0 00.357.432 1.758 1.758 0 00.335.032h13.094a.491.491 0 00.5-.475.486.486 0 00-.508-.465h-.227c-2.12.011-4.259.011-6.399.011zm-.022-2.269H2.744a1.737 1.737 0 00-.335.011.454.454 0 00.011.9 2.35 2.35 0 00.281.011h12.954a1.6 1.6 0 00.227-.011.471.471 0 00.443-.465.463.463 0 00-.454-.454 2.437 2.437 0 00-.281 0c-2.15.008-4.3.008-6.439.008zM6.3 15.655h3.662a1.377 1.377 0 00.3-.022.424.424 0 00.346-.454.415.415 0 00-.367-.432 1.427 1.427 0 00-.3-.022H2.69c-.108 0-.259-.022-.324.043a.953.953 0 00-.324.4.369.369 0 00.281.454 1.29 1.29 0 00.357.043c1.209-.01 2.409-.01 3.62-.01z"
                          className="a"
                        />
                        <path
                          d="M4.829 10.836V8.729h16.379v2.107zM18.755 4.71c-.14.011-.216.022-.3.022H15.72c-.583 0-.8-.216-.8-.8V.745zM3.868 10.329H2.96V9.27h.908zM22.072 9.129c.367.238.681.443 1.026.67a51.3 51.3 0 00-1.026.67z"
                          className="a"
                        />
                      </svg>
                    </span>
                  </Link>
                  <Link
                    to="/referral/history"
                    className="referral-tab-mobile v-btn v-btn--has-bg v-btn--router theme--light elevation-0 v-size--default"
                  >
                    <span className="v-btn__content">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24.986"
                        height={25}
                        className="mobile-icon"
                      >
                        <defs />
                        <path
                          d="M13.222.014c.479.063.966.12 1.445.2a11.716 11.716 0 012.46.7c-.176.451-.352.888-.536 1.346a10.926 10.926 0 00-9.734.775 10.485 10.485 0 00-4.8 5.871A11.031 11.031 0 1021.32 5.953c-.049.367-.1.7-.148 1.064-.486-.063-.959-.127-1.445-.183.141-1.128.282-2.227.43-3.348H23.5v1.438h-1.073c.07.106.106.169.155.233a12.279 12.279 0 012.361 6.407c.007.07.028.141.042.211v1.515l-.042.211c-.106.655-.162 1.325-.31 1.966a12.441 12.441 0 01-9.966 9.339c-.465.078-.93.127-1.4.19h-1.511l-.211-.042c-.655-.1-1.325-.162-1.966-.31A12.512 12.512 0 01.191 14.65c-.078-.458-.127-.916-.19-1.374v-1.562c.063-.465.113-.93.19-1.4A12.482 12.482 0 0110.29.2c.472-.078.944-.134 1.424-.2.501.014 1.001.014 1.508.014z"
                          className="a"
                        />
                        <path
                          d="M12.496 20.75a8.246 8.246 0 118.239-8.239 8.26 8.26 0 01-8.239 8.239zm3.376-9.05h-2.593V9.127h-1.565v4.151h4.158z"
                          className="a"
                        />
                      </svg>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          {isEmpty(user) ? (
            <div className="v-card__text referralContainer">
              <div className="row">
                <div className="text-center col col-12">
                  <label color="title_color2">
                    {t("LoginRegisterEarnPoints")}
                  </label>
                </div>
                <div className="text-center col col-12">
                  <button
                    onClick={() => setLoginModalShow(true)}
                    type="button"
                    className="mr-6 primary-button embedded-login-button pa-2 font-weight-bold text_reverse--text v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary"
                    style={{ height: "auto" }}
                  >
                    <span className="v-btn__content">{t("Login")}</span>
                  </button>
                  <button
                    onClick={() => navigate("/register")}
                    type="button"
                    className="mr-6 primary-button embedded-login-button pa-2 font-weight-bold text_reverse--text v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary"
                    style={{ height: "auto" }}
                  >
                    <span className="v-btn__content">{t("Singup")}</span>
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="v-card__text referralContainer">
              <div>
                <div className="row">
                  <div className="col-md-5 col-12">
                    <div className="row">
                      <div className="col col-12">
                        <div className="commission-content-holder full-height primary white--text text-center pa-2 mb-3 v-card v-sheet theme--light elevation-0">
                          <div className="v-card__text">
                            <div className="row no-gutters justify-center">
                              <div className="mb-3 col col-9">
                                <label className="white--text">
                                  {t("CommissionToRedeem")}
                                </label>
                              </div>
                              <div className="mb-0 col col-9">
                                <form
                                  noValidate="novalidate"
                                  className="v-form"
                                >
                                  <div className="mobile">
                                    <div className="row no-gutters justify-space-between">
                                      <div className="col col-10" />
                                      <div className="col col-2" />
                                      <div className="col col-12">
                                        <div className="v-input input-field elevation-0 hide-details v-input--is-label-active v-input--is-dirty v-input--is-disabled v-input--is-readonly theme--light v-text-field v-text-field--prefix v-text-field--is-booted v-text-field--enclosed v-text-field--outlined commission-redeem-field input-field elevation-0 hide-details">
                                          <div className="v-input__control">
                                            <div className="v-input__slot">
                                              <fieldset aria-hidden="true">
                                                <legend
                                                  style={{ width: "0px" }}
                                                >
                                                  <span className="notranslate">
                                                    ​
                                                  </span>
                                                </legend>
                                              </fieldset>
                                              <div className="v-text-field__slot">
                                                <div className="v-text-field__prefix">
                                                  ৳
                                                </div>
                                                <input
                                                  autoComplete="new-password"
                                                  disabled
                                                  readOnly
                                                  type="text"
                                                  value={
                                                    profileData?.commissionToRedeem ??
                                                    "0.00"
                                                  }
                                                />
                                              </div>
                                            </div>
                                            <div className="v-text-field__details">
                                              <div className="v-messages theme--light">
                                                <div className="v-messages__wrapper" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </form>
                              </div>
                              <div className="col col-9">
                                <button
                                  type="button"
                                  className="pa-2 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default dialog-button text-capitalize"
                                >
                                  <span className="v-btn__content">{t("Redeem")}</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6 col-md-5 col-12">
                        <div className="row no-gutters align-end">
                          <div className="col col-12">
                            <label>{t("TodayCommission")}</label>
                          </div>
                        </div>
                        <div className="row no-gutters">
                          <div className="col col-12">
                            <div className="v-card v-sheet theme--light primary white--text text-left py-2 pl-6 mb-3">
                              ৳ {profileData?.todayCommission ?? "0.00"}
                            </div>
                          </div>
                        </div>
                        <div className="row no-gutters align-end">
                          <div className="col col-12">
                            <label>{t("ThisMonthCommission")}</label>
                          </div>
                        </div>
                        <div className="row no-gutters align-start">
                          <div className="col col-12">
                            <div className="v-card v-sheet theme--light primary white--text text-left py-2 pl-6">
                              ৳ {profileData?.monthCommission ?? "0.00"}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6 col-md-6 col-12">
                        <div className="row">
                          <div className="col col-12">
                            <div className="tier-container">{t("ReferralTier")}</div>
                          </div>
                        </div>
                        <div className="row no-gutters align-end">
                          <div className="col col-6">
                            <div className="v-card v-sheet theme--light elevation-0 border-left-radius primary white--text text-center pa-2 mb-3 mr-1">
                              {t("Total")}
                            </div>
                          </div>
                          <div className="col col-6">
                            <div className="v-card v-sheet theme--light elevation-0 border-right-radius primary white--text text-center pa-2 mb-3 mr-1">
                              {profileData?.referralTierTotal ?? 0}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-7 col-12">
                    <div className="row no-gutters">
                      <div className="col-sm-7 col-md-7 col-12">
                        <div className="commission-content-holder base pa-2 mb-3 full-height v-card v-sheet theme--light elevation-0">
                          <div className="v-card__text">
                            <div className="row no-gutters">
                              <div
                                className="d-flex flex-column justify-center col-md-7 col-10"
                                style={{ margin: "auto" }}
                              >
                                <div className="row no-gutters">
                                  <div className="col">{t("IDLabel")}</div>
                                  <div className="font-weight-bold text-right col">
                                    {user?.id ?? "-"}
                                  </div>
                                </div>
                                <div className="row no-gutters">
                                  <div className="col">{t("ReferralCodeLabel")}</div>
                                  <div
                                    className="font-weight-bold text-right col"
                                    style={{ cursor: "pointer" }}
                                    onClick={copyToClipboard}
                                  >
                                    {profileData?.referalCode}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row d-flex justify-center">
                              <div className="d-flex justify-center col col-12">
                                <div className="qrCode" title={referralUrl}>
                                  <QRCodeCanvas
                                    value={referralUrl}
                                    size={105}
                                    bgColor="#ffffff"
                                    fgColor="#000000"
                                    level="H"
                                  />
                                </div>
                              </div>
                              <div className="mb-0 col-sm-8 col-md-12 col-12">
                                <div className="row no-gutters justify-center">
                                  <div className="col-lg-6 col-8">
                                    <button
                                      type="button"
                                      onClick={handleShare}
                                      className="dialog-button subtitle-1 full-width text-capitalize pa-2 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                                    >
                                      <span className="v-btn__content">
                                        <i
                                          aria-hidden="true"
                                          className="v-icon notranslate mr-2 material-icons theme--light"
                                        >
                                          share
                                        </i>
                                        {t("ShareNow")}
                                      </span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default Refrel;
